export const changeData = (data) => {
  let arr = []
  data.forEach(item=>{
    arr.push({
      newChange:false,
      airlineName:item.airlineName,
      departDate:item.oDepartDate,
      departWeek:item.oDepartWeek,
      departTime:item.oDepartTime,
      arriveDate:item.oArriveDate,
      arriveWeek:item.oArriveWeek,
      arriveTime:item.oArriveTime,
      departAirportName:item.oDepartAirportName,
      arriveAirportName:item.oArriveAirportName,
      departTerminal:item.oDepartTerminal,
      arriveTerminal:item.oArriveTerminal,
      departCityName:item.oDepartCityName,
      arriveCityName:item.oArriveCityName,
      flightNo:item.oFlightNo,
      model:item.oModel,
      cabinName:item.oCabinName,
      cabin:item.oCabin,
      stopFlag:item.oStopFlag,
      stopCity:item.oStopCity,
      stopCityName:item.oStopCityName,
      stopAirport:item.oStopAirport,
      stopAirportName:item.oStopAirportName,
      stopArriveTime:item.oStopArriveTime,
      stopDepartTime:item.oStopDepartTime,
    },
    {
      newChange:true,
      airlineName:item.airlineName,
      arriveWeek:item.narriveWeek,
      flightNo:item.nFlightNo,
      model:item.nModel,
      cabinName:item.nCabinName,
      cabin:item.nCabin,
      departAirportName:item.nDepartAirportName,
      arriveAirportName:item.nArriveAirportName,
      departCityName:item.nDepartCityName,
      arriveCityName:item.nArriveCityName,
      departDate:item.nDepartDate,
      departTime:item.nDepartTime,
      departWeek:item.nDepartWeek,
      arriveDate:item.nArriveDate,
      arriveTime:item.nArriveTime,
      departTerminal:item.nDepartTerminal,
      arriveTerminal:item.nArriveTerminal,
      flyTime:item.nFlyTime,
      refundRule:item.nRefundRule,
      changeRule:item.nChangeRule,
      upgradeRule:item.nUpgradeRule,
      stopFlag:item.nStopFlag,
      stopCity:item.nStopCity,
      stopCityName:item.nStopCityName,
      stopAirport:item.nStopAirport,
      stopAirportName:item.nStopAirportName,
      stopArriveTime:item.nStopArriveTime,
      stopDepartTime:item.nStopDepartTime,
      shareFlightNo:item.nShareFlightNo,
    })
  })
  return arr
}